module.exports = __webpack_public_path__ + "static/media/don-2.9c49ecd8.png";